import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { Nullable } from "../../base-types.js";
import { EntityLoadConfiguration, IEntityLoadConfiguration } from "./entity-load-configuration";
import { QueryNodeFilter } from "./search/query-node-filter";
import { Sorting } from "./sorting";

@JsonObject()
export class SearchAfterQuery {
    /**
     * The type of filter to be invoked.
     */
    @JsonProperty("filter")
    filter: QueryNodeFilter;

    /**
     * The number of items to take. If not specified, the underlying implementation will use a default value.
     */
    @JsonProperty("take")
    take: number = 50;

    /**
     * The sorting options to be applied.
     */
    @JsonProperty("sorting")
    @JsonElementType(Sorting)
    sorting: Array<Sorting>;

    /**
     * A list of sort values to retrieve the next page of results.
     */
    @JsonProperty("search_after")
    @JsonElementType(String)
    searchAfter?: Nullable<Array<string>>;

    /**
     * Configuration to load with the results.
     */
    @JsonProperty("load_configuration")
    @JsonElementType(EntityLoadConfiguration)
    loadConfiguration?: Nullable<IEntityLoadConfiguration>;

    /**
     * The renditions to be applied.
     */
    @JsonProperty("renditions")
    @JsonElementType(String)
    renditions?: Nullable<Array<string>>;

    /**
     * The nested relations to be applied.
     */
    @JsonProperty("nested_relations")
    @JsonElementType(String)
    nestedRelations?: Nullable<Array<string>>;

    constructor(init?: Partial<SearchAfterQuery>) {
        Object.assign(this, init);
    }
}
